/**
 * CRM Multi-Compagnia · Quadratura post-import SIA
 */
import { useState } from "react";
import { Scale, CheckCircle2, XCircle, RefreshCw } from "lucide-react";
import {
  api, Btn, Field, TextInput, Spinner, ErrorBox, fmtEUR, toast
} from "@/components/crm-multi/shared";

export default function SiaReconcilePage() {
  const [dichiarato, setDichiarato] = useState({
    totale_clienti_sia_dichiarato: 0,
    totale_polizze_sia_dichiarato: 0,
    totale_premi_sia_dichiarato: 0,
    totale_sinistri_sia_dichiarato: 0,
    totale_incassi_sia_dichiarato: 0,
  });
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const calcola = async () => {
    setLoading(true); setError(null);
    try {
      const r = await api.post("/sia/reconcile", { dichiarato });
      setReport(r);
    } catch (e) { setError(e?.response?.data?.detail || e.message); }
    finally { setLoading(false); }
  };

  const u = (k) => (e) => setDichiarato({ ...dichiarato, [k]: parseFloat(e.target.value || 0) });

  const ROWS = [
    ["totale_clienti", "Clienti", false],
    ["totale_polizze", "Polizze", false],
    ["totale_premi", "Premi totali", true],
    ["totale_sinistri", "Sinistri", false],
    ["totale_incassi", "Incassi", false],
  ];

  return (
    <div className="space-y-5 max-w-4xl" data-testid="sia-reconcile-page">
      <header>
        <h2 className="text-xl font-semibold flex items-center gap-2"><Scale className="w-5 h-5" /> Quadratura post-import</h2>
        <p className="text-sm text-zinc-500">Inserisci i totali dichiarati da SIA per confrontarli con i dati attuali nel CRM</p>
      </header>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-white border rounded-lg p-4 space-y-3" data-testid="sia-reconcile-form">
          <h3 className="font-semibold text-sm">Totali dichiarati da SIA</h3>
          {ROWS.map(([k, label]) => (
            <Field key={k} label={label}>
              <TextInput type="number" step="0.01" value={dichiarato[`${k}_sia_dichiarato`]}
                onChange={u(`${k}_sia_dichiarato`)} data-testid={`sia-reconcile-${k}`} />
            </Field>
          ))}
          <Btn variant="primary" onClick={calcola} disabled={loading} data-testid="sia-reconcile-submit">
            {loading ? <Spinner size="w-4 h-4" /> : <RefreshCw className="w-4 h-4" />} Calcola quadratura
          </Btn>
          <ErrorBox error={error} />
        </div>

        <div className="bg-white border rounded-lg p-4">
          <h3 className="font-semibold text-sm mb-3">Risultato confronto</h3>
          {!report ? (
            <p className="text-sm text-zinc-400">Compila il form e clicca "Calcola quadratura"</p>
          ) : (
            <table className="w-full text-sm">
              <thead className="text-xs text-zinc-500 uppercase">
                <tr>
                  <th className="text-left py-1">Voce</th>
                  <th className="text-right">SIA</th>
                  <th className="text-right">CRM</th>
                  <th className="text-right">Diff.</th>
                </tr>
              </thead>
              <tbody>
                {ROWS.map(([k, label, money]) => {
                  const sia = dichiarato[`${k}_sia_dichiarato`] || 0;
                  const crm = report.crm?.[`${k}_crm`] || 0;
                  const diff = crm - sia;
                  const isOk = diff === 0;
                  return (
                    <tr key={k} className="border-t border-zinc-100">
                      <td className="py-2">{label}</td>
                      <td className="text-right font-mono text-xs">{money ? fmtEUR(sia) : sia}</td>
                      <td className="text-right font-mono text-xs">{money ? fmtEUR(crm) : crm}</td>
                      <td className="text-right">
                        <span className={`inline-flex items-center gap-1 font-mono text-xs ${isOk ? "text-emerald-700" : "text-rose-700"}`}>
                          {isOk ? <CheckCircle2 className="w-3 h-3" /> : <XCircle className="w-3 h-3" />}
                          {money ? fmtEUR(diff) : diff}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          {report && (
            <div className="mt-3 pt-3 border-t">
              <p className="text-xs text-zinc-500">Generato il {new Date(report.generated_at).toLocaleString("it-IT")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
